<template>
    <div v-show="showWidget" class="widget-content-items">
        <SearchBy class="m-2" :placeholder="'Search by title'" @change="searchText = $event"/>

        <div v-if="noItemsFound" class="pl-3">No item found with this name</div>
        <div v-else-if="emptyContentItems" class="pl-3">No items available</div>

        <WidgetContentItemsList v-show="!doingAjax" :reset-scroll-once="resetScrollOnce" :content-items="contentItems" :project-id="projectId" :article-id="articleId"/>
        <TimelineSidebar v-show="doingAjax" :height="440" :background="'FBFBFB'" class="pl-2 pr-2 pb-2"/>

    </div>
</template>

<script>
import "@/styles/sidebar/widget-content-items.scss";
import SearchBy from "@/components/general/components/SearchBy.vue";
import TimelineSidebar from "@/components/general/TimelineSidebar.vue";
import {FETCH_CONTENT_ITEMS_WIDGET} from "@/store/general/widget-content-items/actions";
import {mapState} from "vuex";
import ActionCaller from "@/mixins/general/action-caller";
import WidgetContentItemsList from "./components/WidgetContentItemsList";
import {APPROVE_ASSIGMENT_EVENT, CHANGE_ASSIGNMENT_STATUS_EVENT, REJECT_ARTICLE_EVENT} from "@/utils/event-bus";

export default {
    name: 'WidgetContentItems',
    computed: {
        ...mapState({
            contentItems: state => state.widgetContentItems.contentItems,
        }),
        noItemsFound: vm => vm.searchText && vm.contentItems.length === 0 && vm.showMessage,
        emptyContentItems: vm => vm.contentItems.length === 0 && vm.showMessage,
    },
    methods: {
        refetchData() {
            this.resetScrollOnce = true;
            this.fetchBySearch(this.searchText);
        },
        fetchBySearch(v) {
            this.showMessage = false;
            clearTimeout(this.idSearchText);
            this.idSearchText = setTimeout(() => {
                this.callAction(FETCH_CONTENT_ITEMS_WIDGET, {
                        projectId: this.projectId,
                        payload: {
                            searchTitle: v
                        }
                    },
                    () => {
                        this.showMessage = true;
                        this.resetScrollOnce = false;
                    }
                )
            }, 700);
        }
    },
    components: {WidgetContentItemsList, TimelineSidebar, SearchBy},
    watch: {
        searchText(v) {
            this.fetchBySearch(v);
        },
        showWidget: {
            handler(v) {
                if (v && this.projectId && this.contentItems.length === 0) {
                    this.showMessage = false;
                    this.callAction(FETCH_CONTENT_ITEMS_WIDGET, {projectId: this.projectId}, () => this.showMessage = true);
                }
            },
            immediate: true
        }
    },
    props: {
        articleId: {
            type: Number,
            default: 0
        },
        projectId: {
            type: Number,
            default: 0
        },
        showWidget: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            searchText: '',
            idSearchText: 0,
            showMessage: false,
            resetScrollOnce: false
        }
    },
    mixins: [ActionCaller],
    mounted() {
        window.addEventListener(CHANGE_ASSIGNMENT_STATUS_EVENT, this.refetchData);
        window.addEventListener(APPROVE_ASSIGMENT_EVENT, this.refetchData);
        window.addEventListener(REJECT_ARTICLE_EVENT, this.refetchData);
    },
    beforeDestroy() {
        window.removeEventListener(CHANGE_ASSIGNMENT_STATUS_EVENT, this.refetchData);
        window.removeEventListener(APPROVE_ASSIGMENT_EVENT, this.refetchData);
        window.removeEventListener(REJECT_ARTICLE_EVENT, this.refetchData);
    }
}
</script>
